import React from 'react';
import { render } from 'react-dom';
import { __ } from '@wordpress/i18n';

import { CalculatorCatAge } from '../../calculators/components/Calculator/CalculatorCatAge';

const blockWrapperClass = 'block-container__' + 'cat-age';
const wrappers = document.getElementsByClassName(blockWrapperClass);

const catCalcStrings = {
  title: __('Cat Age Calculator', 'cooperpetcare'),
  age: __('Age of cat', 'cooperpetcare'),
  agePlaceholder: __('Please enter the age of your cat in years', 'cooperpetcare'),
  buttonCalculate: __('Calculate', 'cooperpetcare'),
  petIs: __('Your pet is %s', 'cooperpetcare'),
  resultInYears: __(`In human years your cat is <b>%1s</b> years old and is considered %2s.`, 'cooperpetcare'),
  dogTypes: {
    kitten: {
      article: __('a kitten', 'cooperpetcare'),
      plain: __('kitten', 'cooperpetcare')
    },
    adult: {
      article: __('an adult', 'cooperpetcare'),
      plain: __('adult', 'cooperpetcare')
    },
    senior: {
      article: __('a senior', 'cooperpetcare'),
      plain: __('senior', 'cooperpetcare')
    }
  },
  numbersValidator: __('Value must be a number', 'cooperpetcare'),
  maxValueValidator: __('Value must be less or equal to %s', 'cooperpetcare'),
  minValueValidator: __('Value must be greater than %s', 'cooperpetcare'),
  minDateValueValidator: __('Date must be greater than %s', 'cooperpetcare'),
  requiredFieldValidator: __('Required field', 'cooperpetcare'),
};

for (let wrapper of wrappers) {
  render(<CalculatorCatAge />, wrapper);
}
